import "./scheduled-date.scss";

import classNames from "classnames";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useRef, useState } from "react";

import { ReactComponent as AttentionIcon } from "@client/components/reusable/SvgIcons/library/attention_icon.svg";
import { ReactComponent as CalendarIcon } from "@client/components/reusable/SvgIcons/library/calendar.svg";
import { TDateISO } from "@client/interfaces";

import SvgIcon from "../SvgIcons";
import { ScheduledDatePicker } from "./date-picker";

type ScheduledDateProps = {
	error?: boolean;
	scheduledDate?: string;
	setScheduledDate?: (date: TDateISO | null) => void;
	isPopup?: boolean;
	isReadyTab?: boolean;
};

const ScheduledDate: React.FC<ScheduledDateProps> = ({
	error,
	scheduledDate,
	setScheduledDate,
	isPopup,
	isReadyTab,
}) => {
	const [date, setDate] = useState<Dayjs | null>(
		scheduledDate ? dayjs(scheduledDate) : null
	);
	const anchorRef = useRef<HTMLDivElement>(null);
	const [open, setOpen] = useState(false);

	const handleDateChange = (newDate: Dayjs | null) => {
		setDate(newDate);
		const newDateISO = newDate?.toISOString();
		setScheduledDate?.(newDateISO);
	};

	useEffect(() => {
		setDate(scheduledDate ? dayjs(scheduledDate) : null);
	}, [scheduledDate]);

	const formattedDate = date ? date.format("DD/MM/YY") : "";

	return (
		<div
			className={classNames(
				"scheduled-date-wrapper",
				isPopup ? "scheduled-date-wrapper-popup" : ""
			)}
		>
			{isPopup && (
				<span className="scheduled-date-title">תאריך אספקה מתוכנן</span>
			)}
			<div
				className={classNames("scheduled-date-wrapper-container", {
					"scheduled-date-wrapper-container-disabled": date,
					"scheduled-date-wrapper-container-error": error,
					"scheduled-date-wrapper-container-border": isPopup,
					"scheduled-date-wrapper-container-border-done": isPopup && date,
				})}
				onClick={(e: React.MouseEvent<HTMLDivElement>) => {
					e.preventDefault();
					e.stopPropagation();

					if (date) {
						return;
					}

					setOpen(true);
				}}
			>
				<div
					ref={anchorRef}
					className={classNames(
						"scheduled-date-container",
						error ? "scheduled-date-container-error" : ""
					)}
				>
					{formattedDate ? (
						<span
							className={classNames(
								"scheduled-date-text-date",
								isPopup ? "scheduled-date-text-date-popup" : ""
							)}
						>
							{formattedDate}
						</span>
					) : null}

					{!isReadyTab && (
						<span
							className={classNames(
								"scheduled-date-text",
								formattedDate ? "scheduled-date-text-done" : ""
							)}
						>
							{!isPopup
								? "תאריך אספקה מתוכנן"
								: formattedDate
								? ""
								: "בחר תאריך אספקה מתכונן"}
							{formattedDate && !isPopup ? ":" : ""}
						</span>
					)}

					{!(formattedDate && isPopup) && (
						<SvgIcon
							className={classNames(formattedDate ? "calendar-done" : "")}
							component={CalendarIcon as any}
						/>
					)}
				</div>
			</div>

			<ScheduledDatePicker
				anchorRef={anchorRef}
				open={open}
				setOpen={setOpen}
				setParentDate={handleDateChange}
			/>

			{error && (
				<span className="scheduled-date-text-error">
					יש לעדכן תאריך <SvgIcon component={AttentionIcon} />
				</span>
			)}
		</div>
	);
};

export default ScheduledDate;
